import React from 'react';
import uuidv4 from 'uuid/v4';

const SearchInput = props => {
  const id = uuidv4();
  return (
    <div className="bx--toolbar-search-container">
      <div
        data-search
        className="bx--search bx--search--sm bx--search--light mg-bt-10"
        role="search"
      >
        <svg className="bx--search-magnifier" width="16" height="16" viewBox="0 0 16 16">
          <path
            d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zm4.936-1.27l4.563 4.557-.707.708-4.563-4.558a6.5 6.5 0 1 1 .707-.707z"
            fillRule="nonzero"
          />
        </svg>
        <label htmlFor={id} className="bx--label">
          Buscar
        </label>
        <input id={id} className="bx--search-input" type="text" role="search" {...props} />
      </div>
    </div>
  );
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/SearchInput.js